import http from 'hub-http/clients/apiClient';
export const deleteOutboundRecording = (callSid, engagementId) => {
  return http.delete(`twilio/v1/calls/browsercall/${callSid}/recording?retryOnFailure=true&engagementId=${engagementId}`);
};